import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=8eb9ae3c&lang=scss&scoped=true"
script.__scopeId = "data-v-8eb9ae3c"

export default script